export enum TutorialExtraCategoryIdEnum {
  All = 0,
  Latest = -1,
  Popular = -2,
  Saved = -3,
  Recommended = -4,
  History = -5,
}

export enum TutorialListTypeEnum {
  Latest = 'latest',
  Recommended = 'recommended',
  Popular = 'popular',
  Tag = 'tags',
  Saved = 'saved',
  History = 'history',
}

export const TUTORIAL_EXTRA_CATEGORY_ID_BY_LIST_TYPE: Record<
  TutorialListTypeEnum,
  TutorialExtraCategoryIdEnum
> = {
  [TutorialListTypeEnum.Latest]: TutorialExtraCategoryIdEnum.Latest,
  [TutorialListTypeEnum.Popular]: TutorialExtraCategoryIdEnum.Popular,
  [TutorialListTypeEnum.Saved]: TutorialExtraCategoryIdEnum.Saved,
  [TutorialListTypeEnum.Recommended]:
    TutorialExtraCategoryIdEnum.Recommended,
  [TutorialListTypeEnum.History]: TutorialExtraCategoryIdEnum.History,
  [TutorialListTypeEnum.Tag]: TutorialExtraCategoryIdEnum.All,
};
